import { Link } from "react-router-dom";
import { SUPPORT_EMAIL } from "../../config/links";
import { formatResume, type PausedState } from "../../lib/toolUsage";
import styles from "./ToolCallsPausedBanner.module.css";

type Props = {
  paused: PausedState;
  // Omitted on the usage page itself.
  usageHref?: string;
};

export const ToolCallsPausedBanner = ({ paused, usageHref }: Props): JSX.Element => {
  const what = paused.allApps ? "Your connected apps are paused" : `${paused.appNames.join(", ")} paused`;
  const when =
    paused.resumesAround === null
      ? "They come back on their own shortly."
      : `Expected back around ${formatResume(paused.resumesAround)}.`;
  return (
    <div className={styles.banner} role="status" data-testid="tool-calls-paused">
      <span className={styles.icon} aria-hidden>
        ⏸
      </span>
      <div className={styles.text}>
        <strong>{what}</strong>
        <span>
          {" "}
          because your agent hit its tool-call limit. {when} You can still chat with your agent. If this is
          normal use for your business,{" "}
          <a className={styles.inlineLink} href={`mailto:${SUPPORT_EMAIL}?subject=Tool-call%20limit`}>
            contact support
          </a>{" "}
          and we'll review your limit.
        </span>
      </div>
      {usageHref !== undefined && (
        <Link to={usageHref} className={styles.link}>
          See usage
        </Link>
      )}
    </div>
  );
};
